export default __webpack_public_path__ + "static/media/Logo.6889895f.svg";